import type { RadioTextProps } from '@/components/control/components/radio-text/radio-text.types';
import clsx from 'clsx';
import '@/components/control/components/radio-text/radio-text.css';

export default function RadioText(props: RadioTextProps) {
  return (
    <div
      className={clsx('control-radio-text', {
        'control-radio-text--size-md': props.size === 'md',
        'control-radio-text--size-lg': props.size === 'lg',
        'control-radio-text--align-left': props.align === 'left',
        'control-radio-text--align-center': props.align === 'center',
        'control-radio-text--align-right': props.align === 'right',
        'control-radio-text--one-line': props.oneLine,
      })}
    >
      <span
        data-text={props.children}
        className={clsx('control-radio-text__content', {
          'control-radio-text__content--checked': props.checked,
        })}
        dangerouslySetInnerHTML={{ __html: props.children }}
      />
    </div>
  );
}
